(() => {
  const initHelp = (root) => {
    if (root.dataset.lcHelpReady) return;
    const input = root.querySelector('[data-lc-search]');
    const form = root.querySelector('[data-lc-search-form]');
    const clear = root.querySelector('[data-lc-clear]');
    const counter = root.querySelector('[data-lc-result-count]');
    const empty = root.querySelector('[data-lc-empty]');
    const reset = root.querySelector('[data-lc-reset]');
    const tools = root.querySelector('[data-lc-tools]');
    const expand = root.querySelector('[data-lc-expand]');
    const collapse = root.querySelector('[data-lc-collapse]');
    const results = root.querySelector('.lc-help__results');
    const links = [...root.querySelectorAll('[data-lc-category]')];
    const groups = [...root.querySelectorAll('[data-lc-group]')];
    if (!input || !form || !clear || !counter || !empty || !reset || !results) return;
    root.dataset.lcHelpReady = 'true';
    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[’']/g, '');
    const items = [...root.querySelectorAll('[data-lc-question]')].map((element) => ({
      element,
      group: element.closest('[data-lc-group]').dataset.lcGroup,
      text: normalize(element.textContent),
      manualOpen: element.open
    }));
    let category = 'all';
    let searching = false;
    const update = () => {
      const terms = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      const isSearching = terms.length > 0;
      if (isSearching && !searching) items.forEach((item) => { item.manualOpen = item.element.open; });
      let count = 0;
      items.forEach((item) => {
        const visible = (category === 'all' || item.group === category) && terms.every((term) => item.text.includes(term));
        item.element.hidden = !visible;
        if (visible) count += 1;
        if (isSearching) item.element.open = visible;
        else if (searching) item.element.open = item.manualOpen;
      });
      groups.forEach((group) => { group.hidden = !items.some((item) => item.group === group.dataset.lcGroup && !item.element.hidden); });
      links.forEach((link) => {
        const active = link.dataset.lcCategory === category;
        const badge = link.querySelector('.lc-help__count');
        if (badge) badge.textContent = String(items.filter((item) => (link.dataset.lcCategory === 'all' || item.group === link.dataset.lcCategory) && terms.every((term) => item.text.includes(term))).length);
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      counter.textContent = count === 1 ? root.dataset.oneLabel : root.dataset.countLabel.replace('__COUNT__', String(count));
      empty.hidden = count !== 0;
      clear.hidden = input.value.length === 0;
      if (expand) expand.disabled = count === 0;
      if (collapse) collapse.disabled = count === 0;
      searching = isSearching;
    };
    const resetSearch = (all = false) => {
      if (all) category = 'all';
      input.value = '';
      update();
      input.focus();
    };
    const resolveHash = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return null; }
      if (!id) return null;
      const direct = document.getElementById(id);
      if (direct && root.contains(direct) && (direct.matches('[data-lc-question], [data-lc-group]') || direct === results)) return direct;
      const question = id.match(/^(?:lc-help-)?(?:question-|q)(\d{1,2})$/);
      if (question) return items.find((item) => item.element.dataset.lcQuestionId === question[1].padStart(2, '0'))?.element || null;
      const groupName = id.replace(/^lc-help-group-/, '').replace(/^topic-/, '');
      return groups.find((group) => group.dataset.lcGroup === groupName) || null;
    };
    const navigateHash = () => {
      const target = resolveHash();
      if (!target) return;
      category = target === results ? 'all' : target.matches('[data-lc-question]') ? target.closest('[data-lc-group]').dataset.lcGroup : target.dataset.lcGroup;
      input.value = '';
      update();
      let focusTarget = results;
      if (target.matches('[data-lc-question]')) {
        target.open = true;
        focusTarget = target.querySelector('summary');
      } else if (target.matches('[data-lc-group]')) focusTarget = target.querySelector('h3');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      if (typeof target.scrollIntoView === 'function') target.scrollIntoView({ block: 'start' });
    };
    form.hidden = false;
    counter.hidden = false;
    if (tools) tools.hidden = false;
    form.addEventListener('submit', (event) => { event.preventDefault(); update(); results.focus({ preventScroll: true }); });
    input.addEventListener('input', update);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && input.value) { event.preventDefault(); resetSearch(); }
    });
    clear.addEventListener('click', () => resetSearch());
    reset.addEventListener('click', () => resetSearch(true));
    links.forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      category = link.dataset.lcCategory;
      update();
    }));
    root.querySelectorAll('[data-lc-jump]').forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      window.history.pushState(null, '', link.getAttribute('href'));
      navigateHash();
    }));
    if (expand) expand.addEventListener('click', () => { items.forEach((item) => { if (!item.element.hidden) item.element.open = true; }); });
    if (collapse) collapse.addEventListener('click', () => { items.forEach((item) => { if (!item.element.hidden) item.element.open = false; }); });
    window.addEventListener('hashchange', navigateHash);
    root.addEventListener('lc-help:destroy', () => window.removeEventListener('hashchange', navigateHash), { once: true });
    update();
    navigateHash();
  };
  const initAll = (scope) => {
    if (scope.matches?.('[data-lc-help]')) initHelp(scope);
    scope.querySelectorAll('[data-lc-help]').forEach(initHelp);
  };
  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-lc-help]').forEach((root) => root.dispatchEvent(new Event('lc-help:destroy')));
  });
})();
